/**
 * Default column capabilities configuration
 *
 * These defaults ensure backward compatibility while providing sensible
 * behavior for columns that don't explicitly specify capabilities.
 */

export const DEFAULT_COLUMN_CAPABILITIES = {
  sortable: true, // Most columns should be sortable
  filterable: true, // Most columns should be filterable
} as const;

/**
 * Helper function to get column capabilities with defaults applied
 */
export function getColumnCapabilities(column: {
  sortable?: boolean;
  filterable?: boolean;
}) {
  return {
    sortable: column.sortable !== false, // Default to true if not explicitly false
    filterable: column.filterable !== false, // Default to true if not explicitly false
  };
}
